import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-calendar';
export var ID = 'icon-calendar';
/* eslint-disable max-len */

export var SVGCalendar = function SVGCalendar() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 17 17"
  }, React.createElement("path", {
    d: "M15.64 2.79c-.244-.24-.533-.36-.866-.36h-1.23v-.912c0-.417-.152-.775-.453-1.072C12.79.15 12.428 0 12.005 0h-.616c-.423 0-.785.15-1.087.446-.3.297-.45.655-.45 1.072v.91H6.155v-.91c0-.417-.15-.775-.452-1.072C5.402.15 5.04 0 4.617 0H4c-.422 0-.784.15-1.086.446-.3.297-.452.655-.452 1.072v.91h-1.23c-.334 0-.623.12-.867.36-.243.24-.365.526-.365.855v12.143c0 .328.122.613.365.854.244.24.533.36.866.36h13.544c.333 0 .622-.12.865-.36s.365-.526.365-.854V3.643c0-.33-.122-.614-.366-.854zM4 15.785H1.23v-2.733H4v2.733zm0-3.34H1.23V9.41H4v3.036zm0-3.642H1.23V6.07H4v2.734zm-.215-4.34c-.06-.06-.09-.132-.09-.214V1.518c0-.082.03-.153.09-.213s.133-.09.216-.09h.617c.083 0 .155.03.216.09.06.06.092.13.092.213V4.25c0 .082-.03.153-.092.213-.06.06-.133.09-.216.09H4c-.082 0-.154-.03-.215-.09zm3.91 11.322H4.617v-2.733h3.078v2.733zm0-3.34H4.617V9.41h3.078v3.036zm0-3.642H4.617V6.07h3.078v2.734zm3.693 6.982H8.31v-2.733h3.078v2.733zm0-3.34H8.31V9.41h3.078v3.036zm0-3.642H8.31V6.07h3.078v2.734zm-.216-4.34c-.06-.06-.09-.132-.09-.214V1.518c0-.082.03-.153.09-.213s.133-.09.216-.09h.616c.083 0 .155.03.216.09.06.06.09.13.09.213V4.25c0 .082-.03.153-.09.213s-.133.09-.216.09h-.616c-.083 0-.156-.03-.216-.09zm3.602 11.322h-2.77v-2.733h2.77v2.733zm0-3.34h-2.77V9.41h2.77v3.036zm0-3.642h-2.77V6.07h2.77v2.734z",
    fill: "#BAB7B6",
    fillRule: "evenodd"
  }));
};
/* eslint-disable max-len */

var Calendar = function Calendar(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGCalendar
  });
};

Calendar.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Calendar;